import { defineComponent, ref } from 'vue'
import { useField, useForm } from 'vee-validate'
import ru from 'yup-locale-ru'
import { host } from '@/const'
import axios from '@/axios'
import * as yup from 'yup'
import Select from '@/components/select'
import Preloader from '@/components/preloader/preloader.vue'
import './style.sass'
import PersonalDataCheckbox from "@/components/personal-data-checkbox";

export default defineComponent({
  props: {
    closeFeedbackModal: {
      type: Function,
      default: (value: boolean) => { return value }
    },
    isSuccessUpload: {
      type: Function,
      default: (value: boolean) => { return value }
    },
    typeFiles: {
      type: String,
      default: () => 'orders'
    },
    orders: {
      type: Array,
      default: () => []
    }
  },
  setup (props) {
    yup.setLocale(ru)

    const corplaints = ref([
      { id: 1, title: 'Проблема с заявкой' },
      { id: 2, title: 'Проблема с работой личного кабинета' },
      { id: 1, title: 'Проблема с работой менеджера' }
    ])

    const preloader = ref(false)
    const errorResponse = ref('')
    const successResponse = ref(false)

    const endpoint = ref('/api/v1/client/complaint')
    const FILE_SIZE = 15 * 1048576 // 15 мегабайт в байтах
    const uploadFilePercentage = ref(0)
    const SUPPORTED_FORMATS = [
      'image/jpg',
      'image/jpeg',
      'image/png'
    ]

    const schema = yup.object().shape(
      {
        corplaint: yup.string().required(),
        message: yup.string().required(),
        files: yup.mixed()
          .test(
            'fileSize',
            'Один из файлов слишком большой, не более 15MB',
            files => {
              let isNotError = true
              if (files !== undefined) {
                files.map((file: File) => {
                  isNotError = !(file.size > FILE_SIZE)
                  return isNotError
                })
              }
              return isNotError
            }
          )
          .test(
            'fileLength',
            'Файлов более 10-ти',
            files => {
              let isNotError = true
              if (files !== undefined) {
                files.map(() => {
                  isNotError = !(files.length > 10)
                  return isNotError
                })
              }
              return isNotError
            }
          )
          .test(
            'fileFormat',
            'Один из форматов не поддерживается',
            files => {
              let isNotError = true
              if (files !== undefined) {
                for (const key in files) {
                  errorResponse.value = ''
                  if (SUPPORTED_FORMATS.includes(files[key].type)) {
                    uploadFilePercentage.value = 0
                    preloader.value = false
                    isNotError = true
                  } else {
                    isNotError = false
                    break
                  }
                }
              }
              return isNotError
            }
          ),
        personalData: yup.boolean()
          // @ts-ignore
          .oneOf([true], "Вы не дали согласие")
          .test("only-yes", "Вы не дали согласие", value => value === true)
      }
    )

    type FormInputs = {
      corplaint: string
      message: string
      files: File[],
      personalData: boolean
    }

    // @ts-ignore
    const { handleSubmit } = useForm<FormInputs>({ validationSchema: schema })

    const onSubmit = handleSubmit(async () => {
      console.log('handleSubmit', corplaint.value)
      const formData: FormData = new FormData()

      preloader.value = true

      if(files.value !== undefined) {

        files.value.map((item, key) => {
          formData.append('files[]', files.value[key])
        })

        axios.post(`${host}/api/v1/client/complaint/files/create`, formData)
          .then(json => {
            if (json.status === 200 || json.status === 201) {
              const createFileResult = ref([])
              createFileResult.value = json.data

              if (uploadFilePercentage.value === 0 && createFileResult.value.length > 0) {
                preloader.value = true

                const data = {
                  files: createFileResult.value,
                  message: message.value,
                  type: corplaint.value
                }
                uploadFilePercentage.value = 1

                axios.post(`${host}${endpoint.value}`, data)
                  .then(json => {
                    if (json.status === 200 || json.status === 201) {
                      successResponse.value = true
                      uploadFilePercentage.value = 0
                      props.isSuccessUpload()
                    }
                    preloader.value = false
                  })
                  .catch(e => {
                    console.log(e)
                    filesError.value = ''
                    errorResponse.value = 'Ошибка запроса, попробуйте повторить позже'
                    uploadFilePercentage.value = 0
                  })
                  .finally(() => {
                    preloader.value = false
                    uploadFilePercentage.value = 100
                  })
              }
            }
            preloader.value = false
          })
          .catch(e => {
            console.log(e)
            filesError.value = ''
            errorResponse.value = 'Ошибка запроса, попробуйте повторить позже'
            uploadFilePercentage.value = 0
          })

      } else {
        const data = {
          message: message.value,
          type: corplaint.value
        }

        axios.post(`${host}${endpoint.value}`, data)
          .then(json => {
            if (json.status === 200 || json.status === 201) {
              successResponse.value = true
              props.isSuccessUpload()
            }
            preloader.value = false
          })
          .catch(e => {
            console.log(e)
            filesError.value = ''
            errorResponse.value = 'Ошибка запроса, попробуйте повторить позже'
            uploadFilePercentage.value = 0
          })
          .finally(() => {
            preloader.value = false
            uploadFilePercentage.value = 100
          })
      }

      preloader.value = false

    })

    const { value: corplaint, errorMessage: corplaintError } = useField<string>('corplaint')
    const { value: message, errorMessage: messageError } = useField<string>('message')
    const { value: files, errorMessage: filesError } = useField<File[]>('files')
    const { value: personalData, errorMessage: personalError } = useField<boolean | undefined>('personalData')
    personalData.value = false

    if (props.typeFiles === 'person') {
      corplaint.value = 'client'
    }

    function selectFile ($event: Event) {
      const target = $event.target as HTMLInputElement
      files.value = Array(...(target.files as FileList))
      uploadFilePercentage.value = 0
    }

    function dropHandler ($event: DragEvent) {
      // @ts-ignore
      files.value = Array(...$event.dataTransfer?.files)
      uploadFilePercentage.value = 0
      // @ts-ignore
      $event.currentTarget.classList.remove('drag-leave')
      $event.preventDefault()
    }

    function dragoverHandler ($event: DragEvent) {
      // @ts-ignore
      if (!$event.currentTarget.classList.contains('drag-leave')) {
        // @ts-ignore
        $event.currentTarget.classList.add('drag-leave')
      }
      $event.preventDefault()
    }

    function dragleaveHandler ($event: DragEvent) {
      // @ts-ignore
      $event.currentTarget.classList.remove('drag-leave')
    }

    function selectCorplaint (e: Record<string, string>) {
      corplaint.value = e.title
      console.log('selectCorplaint', corplaint.value)
    }

    function selectFirst (values: unknown) {
      // @ts-ignore
      if (values.length > 0 && corplaint.value === undefined) {
        // @ts-ignore
        corplaint.value = values[0].title
        console.log('return')
        // @ts-ignore
        return values[0].title
      }
      return corplaint.value
    }

    function cutPath (name: string) {
      const extension = name.split('.').length > 0 ? `..${name.split('.')[1]}` : '..doc'
      return `${name.substr(0, 6)}${extension}`
    }

    function deleteFile (idx: number) {
      files.value.splice(idx, 1)
    }

    function closeModal ($event: MouseEvent) {
      // @ts-ignore
      if ($event?.target?.classList.value === 'close' || $event?.target?.classList.value === 'overlay') {
        props.closeFeedbackModal()
      }
    }

    return () => (
      <div class="overlay" onClick={($event) => closeModal($event)}>
        <div class="modal">
          <a class="close" onClick={($event) => closeModal($event)}/>
          <p>Оставить жалобу</p>
          <span class="descr">Ваша жалоба будет принята, и обработана отделом контроля качества</span>
          {successResponse.value === true
            ? (
              <div class="success-block">
                <div class="success-icon" />
                <p>Ваша жалоба успешно отправлена!</p>
              </div>
            )
            : (
              <form onSubmit={values => onSubmit(values)} >
                <div class="filters">
                  <Select
                    class="filters-select"
                    options={corplaints.value}
                    value={selectFirst(corplaints.value)}
                    onSelectChange={(e: Record<string, string>) => {
                      selectCorplaint(e)
                    }}
                  />
                  {corplaintError.value
                    ? (<span class="error-message" style="text-align: left;">{corplaintError.value}</span>)
                    : null
                  }
                </div>
                <div class="text">
                  <textarea
                    v-focus
                    placeholder="Текст жалобы"
                    v-model={message.value}
                  />
                  {messageError.value
                    ? (<span class="error-message" style="text-align: left;">{messageError.value}</span>)
                    : null
                  }
                </div>
                <div
                  class="document-block"
                  onDrop={($event) => dropHandler($event)}
                  onDragover={($event) => dragoverHandler($event)}
                  onDragleave={($event) => dragleaveHandler($event)}
                >
                  <div class="document">
                    <span style="margin-top: 20px;">Добавьте до 10 изображений <br/>в формате png, jpg</span>
                    <input
                      multiple
                      type="file"
                      id="document"
                      name="document[]"
                      onChange={($event) => selectFile($event)}
                    />
                    {preloader.value && uploadFilePercentage.value < 100
                      ? (<Preloader style="position: relative; margin: 30px auto; top: -10px;"/>)
                      : (
                        <label for="document" class="file-upload-doc">
                          Добавить
                        </label>
                      )
                    }
                    {uploadFilePercentage.value > 0 && !errorResponse.value
                      ? (
                        <div class="progress-file">
                          <div class="pregress-bar">
                            <div class="custom-progress" style={`width:${uploadFilePercentage.value}%`}/>
                            <progress max="100"/>
                          </div>
                          <span>{uploadFilePercentage.value}%</span>
                        </div>
                      )
                      : null
                    }
                    {files.value && !filesError.value && !errorResponse.value
                      ? (
                        <div class="files">
                          {files.value.map((file, index) => (
                            <div class="file-info">
                              <a class="delete-file" onClick={() => deleteFile(index)}/>
                              <div
                                class={file.name.split('.') ? `${file.name.split('.')[1]}-icon` : 'doc-icon'}
                              />
                              <span class="file-upload-path">{'name' in file ? cutPath(file.name) : ''}</span>
                            </div>
                          ))}
                        </div>
                      )
                      : null
                    }
                    {filesError.value
                      ? (<span class="error-message">{filesError.value}</span>)
                      : null
                    }
                    {errorResponse.value
                      ? (<span class="error-message">{errorResponse.value}</span>)
                      : null
                    }
                  </div>
                </div>
                <PersonalDataCheckbox style="margin-top: 10px;" personalData={personalData} personalError={personalError} />
                {preloader.value && uploadFilePercentage.value === 100
                  ? (<Preloader style="position: relative; margin: 50px auto; top: -10px;"/>)
                  : (<button disabled={errorResponse.value !== '' || preloader.value}>Отправить жалобу</button>)
                }
              </form>
            )
          }
        </div>
      </div>
    )
  }
})